import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from '@ublend-npm/aulaui-core';
import { getHomeViewRole } from '@app/selectors/home';
import { WidgetCard } from '../../common';
import QuickLinkTile from './QuickLinkTile';
import { QUICK_LINKS } from '../constants/quicklinkConstants';
import useBreakpoints from '@app/hooks/useBreakpoints';
import { toggleWidgetPreference } from '../../../../../../actions/home/widgetPreferences';
const QuickLinks: React.FC = () => {
  const currentRole = useSelector(getHomeViewRole);
  const dispatch = useDispatch();
  const { lg, xl } = useBreakpoints();
  const roleHrefKey = currentRole === 'student' ? 'learner' : 'educator';

  const visibleLinks = QUICK_LINKS.filter((link) => link.href[roleHrefKey]);

  const handleHide = () => {
    dispatch(toggleWidgetPreference('home-quick-links-widget', true) as any);
  };

  const menuActions = [{ id: 'hide', label: 'Hide', onClick: handleHide }];

  const isCompact = lg && !xl;

  const content = (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: isCompact ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)',
        columnGap: isCompact ? '8px' : '16px',
        rowGap: '16px',
        overflow: 'visible',
      }}
    >
      {visibleLinks.map((link) => (
        <QuickLinkTile
          key={link.key}
          link={link}
          role={currentRole}
          isCompact={isCompact}
        />
      ))}
    </Box>
  );

  return (
    <>
      {isCompact && (
        <style>{`
    div:has(> [data-widget-id='home-quick-links-widget']) {
      flex-wrap: wrap !important;
    }
    [data-widget-id='home-quick-links-widget'] {
      flex: 1 1 100% !important;
      max-width: 100% !important;
      order: 999 !important;
    }
  `}</style>
      )}
      <WidgetCard title="Quick links" menuActions={menuActions}>
        {content}
      </WidgetCard>
    </>
  );
};

export default QuickLinks;
